/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2024 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2024 - Finnish Meteorological Institute (FMI)
 * Copyright 2024 - The Norwegian Meteorological Institute (MET Norway)
 * */

import i18n from 'i18next';
import type { UseTranslationResponse } from 'react-i18next';
import { useTranslation } from 'react-i18next';
import { CORE_NAMESPACE, coreTranslations } from '@opengeoweb/core';
import { safelyInitI18nForTestsAndStories } from '@opengeoweb/shared';
import {
  TIME_SLIDER_NAMESPACE,
  timesliderTranslations,
} from '@opengeoweb/time-slider';
import {
  WEBMAP_REACT_NAMESPACE,
  webmapReactTranslations,
} from '@opengeoweb/webmap-react';
import capTrans from '../../../locales/cap.json';

export const CAP_NAMESPACE = 'cap';

export const initCapI18n = (): typeof i18n => {
  safelyInitI18nForTestsAndStories(i18n, CAP_NAMESPACE, [
    { ns: CAP_NAMESPACE, translations: capTrans },
    { ns: CORE_NAMESPACE, translations: coreTranslations },
    { ns: TIME_SLIDER_NAMESPACE, translations: timesliderTranslations },
    { ns: WEBMAP_REACT_NAMESPACE, translations: webmapReactTranslations },
  ]);
  return i18n;
};

export const useCapTranslation = (): UseTranslationResponse<
  typeof CAP_NAMESPACE,
  typeof i18n
> => useTranslation(CAP_NAMESPACE);

export { i18n };
